export const INTENTS_SORT_OPTIONS = [
  {
    label: 'Newest first',
    value: '-created_at',
  },
  {
    label: 'Oldest first',
    value: 'created_at',
  },
  {
    label: 'Last Modified',
    value: '-updated_at',
  },
  {
    label: 'A-Z',
    value: 'name',
  },
  {
    label: 'Z-A',
    value: '-name',
  },
];

export const INTENTS_FILTER_OPTIONS = [
  {
    type: 'radiobutton',
    name: 'imported_from_xpack',
    value: '',
    options: [
      {
        label: 'All',
        value: '',
      },
      {
        label: 'Project',
        value: false,
      },
      {
        label: 'xPacks',
        value: true,
      },
    ],
  },
  {
    label: 'Show archived',
    type: 'switch',
    name: 'archived',
    value: '',
    options: [
      {
        label: 'ON',
        value: '',
      },
      {
        label: 'OFF',
        value: false,
      },
    ],
  },
];
